import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import DreamMap from '../components/DreamMap';
import { useAuth } from '../hooks/useAuth';

const DreamMapPage: React.FC = () => {
  const { userId } = useParams();
  const { user } = useAuth();
  const [showPrivate, setShowPrivate] = useState(false);

  return (
    <div className="fixed inset-0">
      <DreamMap userId={userId} showPrivate={showPrivate} />
    </div>
  );
};

export default DreamMapPage; 